import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { AbstractUserComponent } from "../abstract/user.component";
import { EntityBase } from "src/app/entity/EntityBase";
import { SellerContract } from "src/app/entity/SellerContract";
import { User } from "src/app/entity/User";
import { Utility } from "src/app/entity/Utility";
import { Pair } from "src/app/obj/Pair";
import { AuthService } from "src/app/service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "src/app/service/general.service";
import { KilowantContract } from "src/app/entity/KilowantContract";

@Component({
    selector: "app-seller-terms-view-dialog",
    templateUrl: "../../../html/incs/seller-terms-view-dialog.component.html"
})
export class SellerTermsViewDialogComponent extends AbstractUserComponent {
  public contract: KilowantContract = null!;

  constructor(
      router: Router,
      route: ActivatedRoute,
      authService: AuthService,
      analyticsService: AnalyticsService,
      generalService: GeneralService,
      private datepipe: DatePipe,
      public dialogRef: MatDialogRef<any>,
      dialog: MatDialog,
    ) { super(router, route, dialog, analyticsService, generalService, authService); }

  ngOnInit(): void {
     
  }

  cancel(): void {
    this.dialogRef.close(null!);
  }

}
